<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import router from './router'
export default {
  name: 'App',
  data () {
    return {
      cash_point: {},
      cashPointId: localStorage.getItem('cashPointId') || null
    }
  },
  mounted () {
    this.getCashierPoint()
  },
  methods: {
    async getCashierPoint () {
      const response = await axios.get(`/stage-api/business/cashierEquipment/` + this.cashPointId)
      this.cash_point = response.data.data
      console.log(this.cash_point, "this.cash_point")
      if (this.cash_point.status === '禁用') {
        alert('设备已禁用')
        router.push('/error')
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>